import { I18nService } from 'core-app/modules/common/i18n/i18n.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CheckListsUtilsService {
  constructor(private i18n:I18nService) {}
    
    updateRadioOptions(obj: any, type:any): void {
        if (!obj || typeof obj !== 'object') return;
    
        if (Array.isArray(obj)) {
        obj.forEach(item => this.updateRadioOptions(item,type));
        return;
        }
    
        if (obj.type === 'radio') {
        if(type == 'en'){
            obj.options = ['Yes', 'No', 'Nothing'];
        }else{
            obj.options = [this.i18n.t("js.check-lists.template.templateyes"),this.i18n.t("js.check-lists.template.templateno"),this.i18n.t("js.check-lists.template.nothing")];
        }
        }
    
        for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            this.updateRadioOptions(obj[key],type);
        }
        }
    }
}